import { PdfGen } from '../pdf/pdf';
import { OptsBaseTest } from './optsBaseTest';

export const ILayoutBaseTestSymbol = Symbol('LayoutBaseTest');

export interface ILayoutBaseTestGen {
  generate(pdf: PdfGen, opts: OptsBaseTest): Promise<void>;
}
